export default "__VITE_ASSET__CMLxMod6__"